















































import Vue from "vue";
import iwStatusFilter from "@/myImmoweb/filters/StatusFilter.vue";
import iwTransactionFilter from "@/myImmoweb/filters/TransactionFilter.vue";
import { Classified } from "@/shared/interfaces/classified/Classified.interface";
import { ALL_TRANSACTION_TYPES, ALL_STATUS_CLASSIFIED} from "@/shared/scripts/helpers/constants/classifiedTypes";

export default Vue.extend({
    components: {
        iwStatusFilter: iwStatusFilter,
        iwTransactionFilter: iwTransactionFilter
    },

    data: function() {
        return {
            internalSelected: "" as string,
            isMobile: true as boolean,
            isOverlayOpen: false as boolean,
            firstFocusableElement: null as unknown as HTMLElement,
            lastFocusableElement: null as unknown as HTMLElement,
            statusFilterValue: ALL_STATUS_CLASSIFIED as Array<string>,
            transactionFilterValue: ALL_TRANSACTION_TYPES as Array<string>,
            internalClassifiedsList: null as Array<Classified> | null
        };
    },

    computed: {
        myClassifieds: function(): Array<Classified> {
            return this.$store.getters["MyClassifiedsModule/getClassifieds"];
        }
    },

    mounted: function() {
        this.$responsive.registerMediaQuery("from-desktop", () => {
            this.isMobile = false;
        }, () => {
            this.isMobile = true;
        });
    },

    methods : {
        openMobileOverlay: function(): void {
            if(!document.documentElement.classList.contains("js-fullscreen")){
                document.documentElement.classList.add("js-fullscreen");
            }
            this.isOverlayOpen = true;
            this.$emit("openMobileOverlay");


            this.$nextTick(() => {
                const element = this.$el as HTMLElement | null;
                if(element !== null) {
                    let mobileOverlay = element.querySelector("searchbox__mobile-overlay--open") as HTMLElement | null;
                    if(mobileOverlay !== null) {
                        let nodeListOfElements = mobileOverlay.querySelectorAll(
                            "a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), [tabindex=\"0\"]"
                        ) as NodeListOf<HTMLElement> | null;

                        if(nodeListOfElements !== null) {
                            let focusableElements = Array.from(nodeListOfElements) as Array<HTMLElement> | null;

                            if(focusableElements !== null) {
                                this.firstFocusableElement = focusableElements[0];
                                this.lastFocusableElement = focusableElements[focusableElements.length - 1];

                                // Save last focusable element of the modal
                                if(this.firstFocusableElement !== null) {
                                    this.firstFocusableElement.focus();
                                }
                            }
                        }
                    }
                }
            });
        },
        closeMobileOverlay: function() {
            if(document.documentElement.classList.contains("js-fullscreen")){
                document.documentElement.classList.remove("js-fullscreen");
            }
            this.$emit("closeMobileOverlay");
            this.isOverlayOpen = false;
        },
        handleTabPress: function(event: MouseEvent) {
            if(document.documentElement.classList.contains("js-fullscreen")) {
                if (event.shiftKey === true) {
                    //Tab backward
                    if (document.activeElement === this.firstFocusableElement) {
                        event.preventDefault();
                        if(this.lastFocusableElement != null) {
                            this.lastFocusableElement.focus();
                        }
                    }
                } else {
                    // Tab forward
                    if (document.activeElement === this.lastFocusableElement) {

                        event.preventDefault();
                        if(this.firstFocusableElement != null) {
                            this.firstFocusableElement.focus();
                        }
                    }
                }
            }
        },
        transactionFilter: function(transactionType: string) {
            this.$emit("filter-transaction-value", transactionType);
        },
        statusFilter: function(statusType: string) {
            this.$emit("filter-status-value", statusType);
        }
    }
});
